var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion__container cursor-pointer",
      class: { open: _vm.open }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "accordion__header cursor-pointer d-flex flex-row justify-content-start align-items-start",
          on: {
            click: function($event) {
              return _vm.$emit("openChange", !_vm.open)
            }
          }
        },
        [
          _c("h3", [
            _vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.bookTitle) + ")")
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.bookAuthor) + "\n    ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.language) + "\n    ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.publisher) +
            " (" +
            _vm._s(_vm.year) +
            ")\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { css: false },
          on: {
            "before-enter": _vm.beforeOpen,
            enter: _vm.onOpen,
            leave: _vm.onClose
          }
        },
        [
          _vm.open
            ? _c("div", { staticClass: "overflow-hidden" }, [
                _c("hr"),
                _vm._v(" "),
                _c(
                  "table",
                  _vm._l(_vm.infoList, function(info, index) {
                    return _c("tr", { key: index }, [
                      _c("td", { staticClass: "pr-2" }, [
                        _vm._v(_vm._s(info.name))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "pl-2 font-weight-bold" }, [
                        _vm._v(_vm._s(info.value))
                      ])
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "accordion__close bg-transparent border-0 p-0 m-0 ml-auto",
        attrs: { type: "button" }
      },
      [_c("span", { staticClass: "icon-close" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }